import client from '@stores/apollo'
import gql from 'graphql-tag'
import { INeighborhoodImport, IPageInfo } from '@api'
import { NeighborhoodImportFragment, PageInfoFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      employeesNeighborhoodsImports: {
        pageInfo: IPageInfo
        edges: { node: INeighborhoodImport }[]
      }
    }
  }
}

const mutateHandler = handleFetchResult<
  IPayload,
  { pageInfo: IPageInfo; imports: INeighborhoodImport[] }
>({
  handler: ({
    viewer: {
      company: {
        employeesNeighborhoodsImports: { edges, pageInfo },
      },
    },
  }) => ({ pageInfo, imports: edges.map(({ node }) => node) }),
  name: 'Neighborhood Employee Import',
})

export default function list(after?: string): Promise<{
  pageInfo: IPageInfo
  imports: INeighborhoodImport[]
}> {
  return client.gql.query({ query, variables: { after } }).then(mutateHandler)
}

const query = gql`
  query importsQuery($after: String) {
    viewer {
      company {
        employeesNeighborhoodsImports(after: $after, first: 20) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...NeighborhoodImportFragment
            }
          }
        }
      }
    }
  }
  ${NeighborhoodImportFragment}
  ${PageInfoFragment}
`
